<template>
  <section class="section">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("outbox module settings") }}
      </h1>
    </div>

    <providers-datatable />

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
    <provider-modal ref="provider_modal" @success="provider_configured" />
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
} from "@/utils";
import { isEmpty } from "lodash";
import ProviderModal from "./providers_datatable/provider_modal/Index.vue";
import ProvidersDatatable from "./providers_datatable/Index.vue";

export default {
  name: "OutboxSettings",
  components: { ProviderModal, ProvidersDatatable },
  data() {
    return {
      meta: { providers: [] },
    };
  },
  methods: {
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    add_provider() {
      let v = this;
      v.meta.providers.push({ name: "" });
    },
    configure_provider(provider) {
      let v = this;
      v.$refs.provider_modal.show_modal(provider);
    },
    provider_configured(data) {
      console.log("provider_configured", data);
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) v.meta = conf;
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
